import PropTypes from 'prop-types';
import VideoController from './VideoController';
import Config from './config.json';

// Helper utils for a video components
// Especially ComponentPropTypes and ComponentDefaultProps is shared among several components.
export default class VideoControllerUtils {
    static GetComponentPropTypes = () =>
        JSON.parse(
            JSON.stringify({
                src: PropTypes.string,
                srcDash: PropTypes.string,
                srcHls: PropTypes.string,
                configPath: PropTypes.string,
                options: PropTypes.object,
                width: PropTypes.string,
                height: PropTypes.string,
                forceRemount: PropTypes.bool,
            })
        );

    static GetComponentDefaultProps = () =>
        JSON.parse(
            JSON.stringify({
                options: VideoController.defaultOptions,
                width: '100%',
                height: 'auto',
                forceRemount: false,
            })
        );

    static GetConfig = (path, cb) => {
        const configPath = `${Config.videoPathPublic}${path}/${Config.videoConfigName}`;

        fetch(configPath)
            .then((res) => res.json())
            .then((json) => cb(json));
    };
}
